import QuestionnaireContentLevel from "./components/QuestionnaireContentLevel";

import StyledModal from "./style";

const ModalProposalQuestionnaire = ({ onClose, onSuccess, open, userName }) => (
  <StyledModal closable={false} footer={false} open={open} width="100vw">
    <QuestionnaireContentLevel
      handleClose={onClose}
      handleCreateProposal={onSuccess}
      open={open}
      userName={userName}
    />
  </StyledModal>
);

export default ModalProposalQuestionnaire;
